import {
	ROUTE_NAMES_RAPIDBOARD_BOARD,
	ROUTE_NAMES_RAPIDBOARD_USER_BOARD,
	ROUTE_NAMES_SOFTWARE_BOARDS,
	ROUTE_NAMES_SERVICEDESK_BOARDS,
	ROUTE_NAMES_SOFTWARE_TIMELINE,
	ROUTE_NAMES_SOFTWARE_TIMELINE_CLASSIC,
	ROUTE_NAMES_RAPIDBOARD_BACKLOG,
	ROUTE_NAMES_RAPIDBOARD_USER_BACKLOG,
	ROUTE_NAMES_SOFTWARE_BACKLOG,
} from '@atlassian/jira-common-constants/src/spa-routes';
import messages from './messages';

export const getIssueLimitMessages = (routeName: string) => {
	switch (routeName) {
		case ROUTE_NAMES_RAPIDBOARD_BOARD:
		case ROUTE_NAMES_RAPIDBOARD_USER_BOARD:
		case ROUTE_NAMES_SOFTWARE_BOARDS:
		case ROUTE_NAMES_SERVICEDESK_BOARDS:
			return {
				headerMessage: messages.boardHeader,
				descriptionMessage: messages.boardDescription,
			};

		case ROUTE_NAMES_SOFTWARE_TIMELINE:
		case ROUTE_NAMES_SOFTWARE_TIMELINE_CLASSIC:
			return {
				headerMessage: messages.timelineHeader,
				descriptionMessage: messages.timelineDescription,
			};
		case ROUTE_NAMES_RAPIDBOARD_BACKLOG:
		case ROUTE_NAMES_RAPIDBOARD_USER_BACKLOG:
		case ROUTE_NAMES_SOFTWARE_BACKLOG:
		default:
			return {
				headerMessage: messages.backlogHeader,
				descriptionMessage: messages.backlogDescription,
			};
	}
};
